import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=0e3b8746&scoped=true"
import script from "./ChatComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatComponent.vue?vue&type=style&index=0&id=0e3b8746&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b8746",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e3b8746')) {
      api.createRecord('0e3b8746', component.options)
    } else {
      api.reload('0e3b8746', component.options)
    }
    module.hot.accept("./ChatComponent.vue?vue&type=template&id=0e3b8746&scoped=true", function () {
      api.rerender('0e3b8746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documentSearcher/components/SearchAdvanceIA/components/SearchIaBoxQuery/components/ChatComponent.vue"
export default component.exports